import { Hairline, Label } from "@components";
import style from "@styles/pages/oraculo/oraculo.module.scss";

import { Climate, CustomerTag } from "@core/oraculo/CustomerTag";
import { Tag } from "./Tag";

export default ({ tags = {}, customers, filters, onSelectFilters }) => {
  const mountedTags = CustomerTag.fromStats(Climate, tags, customers);
  return (
    <>
      <Hairline solid className="mt-20 mb-20" />

      <Label>Relação de perfis climáticos</Label>

      <div className={style.fourGrid}>
        {mountedTags.map((tag) => (
          <Tag
            key={tag.id}
            id={String(tag.id)}
            name={tag.name}
            description={tag.description}
            icon={tag.icon}
            quantity={tag.quantity}
            percentage={tag.getFormattedPercentage()}
            filters={filters}
            onSelectFilters={onSelectFilters}
          />
        ))}
      </div>
    </>
  );
};
